import {useQuery} from "react-query";
import {getCustomerSites} from "../Api/CustomerApi";
import {Site} from "../Types/type";

const QUERY_KEY = 'sites'

export const useGetSites = () => {
  return useQuery<any, Error, Site[]>(
    QUERY_KEY, () => getCustomerSites()
  );
}